export default "__VITE_ASSET__CLBuiAD9__"